import merge from 'lodash.merge';

import sharedScreen from '#frontend/singleDataLayer/shared/screen.js';

/**
 * Company info screen
 * @param {object} cart cart object
 * @returns {object} builded object to push
 */
export default (cart) => {
	const companyInfoScreen = {
		screen: {
			type: 'checkout',
			section: 'Detail',
			name: 'CompanyInfo'
		}
	};

	return merge(companyInfoScreen, sharedScreen(cart));
};
